<template><span>
    <a href="#" @click="showModal">{{ loading ? 'loading...' : 'expand' }}</a>

    <Modal
            v-if="isModalVisible"
            :quote-hash="quote_hash"
            @close="closeModal"
    />
</span>
</template>
<script>
import Modal from './components/Modal.vue';

export default {
    name: 'App',
    components: {
        Modal,
    },
    data() {
        return {
            isModalVisible: false,
            loading: false,
            quote_hash: null
        };
    },
    methods: {
        async showModal(event) {
            event.preventDefault()
            if (!this.quote_hash || this.quote_hash === 'None') {
                this.loading = true
                try {
                    const params = new URLSearchParams(window.location.search)
                    let server = window.location.hostname === 'localhost' ? 'http://localhost' : ''
                    const response = await this.$http.get(server + '/ws/create_search_quote', {
                        params: {
                            sku_id: this.$parent.sku_id,
                            start_date: params.get('start_date'),
                            end_date: params.get('end_date'),
                            adults: params.get('adults'),
                            children: params.get('children'),
                            pets: params.get('pets'),
                            promo_code: params.get('promo_code')
                        }
                    })
                    if (response.data.quote_hash) {
                        this.quote_hash = response.data.quote_hash
                    }
                } finally {
                    this.loading = false
                }
            }
            this.isModalVisible = true;
        },
        closeModal() {
            this.isModalVisible = false;
        }
    },
    created() {
        this.quote_hash = this.$parent.quote_hash
    },
};
</script>


<style scoped>

</style>